import {
  fetchCreateBulk,
} from '@/api/invitation';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  create(context) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchCreateBulk(state.item)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('reset');
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || 'Failed to create bulk invitations',
        () => commit('reset')
        )
      )
      ;
  },
};
